import template from '@components/expertise/discovery/discovery.module.scss'
import { IDiscoveryCards, ISoftwareDiscoveryPhaseSection } from '../../discovery.state';
import style from './index.module.scss'
import Image from 'next/image'


interface ISoftwareDiscoveryPhaseSectionProps {
    section: ISoftwareDiscoveryPhaseSection;
}

const SoftwareDiscoveryPhaseSectionComponent = ({section}: ISoftwareDiscoveryPhaseSectionProps) => {
    return(
        <section className={`${template.section} ${template.section__block_light} ${style.section}`}>
                <div className={template.container}>
                    <h2 className={`${template.block_large__title} ${template.block_large__title_left} ${template.block_large__title_additional}`}>
                        {section.title}
                    </h2>
                    <div className={template.software__items}>
                        {
                            section.cards.map((item: IDiscoveryCards, index: number) => {
                                return (
                                    <div key={index} className={template.software__item}>
                                        <Image className={template.software__item__image} src={item.iconSrc} width={item.width}
                                            height={item.height} alt={item.title} />
                                        <div className={template.software__item__title}>
                                            {item.title}
                                        </div>
                                        <div className={template.software__item__text}>
                                            {item.text}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
    )
}

export default SoftwareDiscoveryPhaseSectionComponent;